import { MessageCircle, Instagram, Facebook, MapPin, CarFront, Star } from "lucide-react";
import { NAV_LINKS, WA_DEFAULT, WHATSAPP_DISPLAY, INSTAGRAM_URL, INSTAGRAM_HANDLE, FACEBOOK_URL } from "../lib/site";
import { scrollToSection } from "./Header";

export default function Footer() {
  return (
    <footer className="bg-brand-deep text-white grain relative" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-12">
          <div className="max-w-sm">
            <a href="#inicio" onClick={(e) => scrollToSection(e, "#inicio")} data-testid="footer-logo" className="inline-flex">
              <img
                src="https://customer-assets-7cd3h4nn.emergentagent.net/job_cataratas-experienza/artifacts/46i9plwr_WhatsApp%20Image%202026-09-11%20at%2009.27.52.png"
                alt="Magnus Máximo — Guia de Turismo em Foz do Iguaçu"
                className="h-20 w-auto object-contain rounded-2xl bg-white px-3 py-2"
              />
            </a>
            <p className="mt-5 text-white/70 text-base md:text-lg leading-relaxed">
              Conheça Foz do Iguaçu, Argentina e Paraguai com um guia que conhece a região há mais de 15 anos.
            </p>
            <ul className="mt-6 space-y-3 text-base md:text-lg text-white/70">
              <li className="flex items-center gap-3"><MapPin size={18} className="text-accent-soft" /> Foz do Iguaçu — Paraná</li>
              <li className="flex items-center gap-3"><span aria-hidden className="text-base">🇧🇷🇦🇷🇵🇾</span> Tríplice Fronteira</li>
              <li className="flex items-center gap-3"><CarFront size={18} className="text-accent-soft" /> Sprinter para até 18 passageiros</li>
              <li className="flex items-center gap-3"><Star size={18} className="text-accent-soft" /> Mais de 15 anos de experiência</li>
            </ul>
            <div className="mt-7 flex gap-4">
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="grid place-items-center w-12 h-12 md:w-14 md:h-14 rounded-full bg-white/10 transition-colors duration-300 hover:bg-accent">
                <Instagram size={22} />
              </a>
              <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" aria-label="Facebook" className="grid place-items-center w-12 h-12 md:w-14 md:h-14 rounded-full bg-white/10 transition-colors duration-300 hover:bg-[#1877F2]">
                <Facebook size={22} />
              </a>
              <a href={WA_DEFAULT} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" aria-label="WhatsApp" className="grid place-items-center w-12 h-12 md:w-14 md:h-14 rounded-full bg-white/10 transition-colors duration-300 hover:bg-whatsapp">
                <MessageCircle size={22} />
              </a>
            </div>
            <p className="mt-5 text-sm md:text-base text-white/60">
              Instagram: <span className="text-white/85 font-semibold">{INSTAGRAM_HANDLE}</span> · WhatsApp: <span className="text-white/85 font-semibold">{WHATSAPP_DISPLAY}</span>
            </p>
          </div>

          <nav className="grid grid-cols-2 gap-x-16 gap-y-4" data-testid="footer-nav">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => scrollToSection(e, l.href)}
                data-testid={`footer-link-${l.href.slice(1)}`}
                className="text-base md:text-lg text-white/75 transition-colors duration-300 hover:text-accent-soft"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-sm text-white/50">
          <p>© {new Date().getFullYear()} Magnus Máximo — Guia de Turismo em Foz do Iguaçu, Paraná, Brasil.</p>
          <p>Brasil · Argentina · Paraguai</p>
        </div>
      </div>
    </footer>
  );
}
